import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthStore {
  token: string | null;
  customerId: number | null;
  customerName: string | null;
  isAuthenticated: boolean;
  canManageStoreSettings: boolean;
  login: (token: string, customerId: number, name: string, canManageStoreSettings: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      token: null,
      customerId: null,
      customerName: null,
      isAuthenticated: false,
      canManageStoreSettings: false,

      login: (token, customerId, name, canManageStoreSettings) => {
        localStorage.setItem('store_token', token);
        set({ token, customerId, customerName: name, isAuthenticated: true, canManageStoreSettings });
      },

      logout: () => {
        localStorage.removeItem('store_token');
        sessionStorage.removeItem('babychic-checkout-state');
        set({ token: null, customerId: null, customerName: null, isAuthenticated: false, canManageStoreSettings: false });
      },
    }),
    { name: 'babychic-auth' }
  )
);
